import axios from "axios";
import {Member} from "../app/modules/users/members/Members";

export class AppApi {

    static adminLogIn(data: { username: string, password: string }) {
        return axios({method: 'post', url: 'hotels/auth/login', data: data})
    }

    static changePassword(data: { current_password: string, new_password: string, confirm_password: string }) {
        return axios({method: 'post', url: 'hotels/auth/changePassword', data: data})
    }

    static resetPassword(data: { email_address: string }) {
        return axios({method: 'post', url: 'hotels/auth/forgotPassword', data: data})
    }

    /*Administrators*/
    static getAdministrators() {
        return axios({method: 'get', url: 'hotels/users/administrators/list'})
    }

    static saveAdministrator(data: {
        admin_id: number, first_name: string, last_name: string,
        email_address: string, username: string, password: string
    }) {
        return axios({method: 'post', url: 'hotels/users/administrators/save', data: data})
    }

    /*Members*/
    static getMembers() {
        return axios({method: 'get', url: 'hotels/users/members/list'})
    }

    static saveMember(data: Member) {
        return axios({method: 'post', url: 'hotels/users/members/save', data: data})
    }

    static getMembershipTypes() {
        return axios({method: 'get', url: 'hotels/users/memberships/list'})
    }

    static saveMembership(data: { membership_type_id: number, type_name: string, registration_fee: number }) {
        return axios({method: 'post', url: 'hotels/users/memberships/save', data: data})
    }

    static getMemberRegions() {
        return axios({method: 'get', url: 'hotels/users/regions/list'})
    }

    static saveMemberRegion(data: { regionId: string, regionName: string }) {
        return axios({method: 'post', url: 'hotels/users/regions/save', data: data})
    }
    
    /*Messaging*/
    static initiateMessaging() {
        return axios({method: 'get', url: 'hotels/messaging/initiate'})
    }

    static sendSMS(data: { message: string, selectedNumbers: string }) {
        return axios({method: 'post', url: 'hotels/messaging/sms', data: data})
    }

    static sendEmail(data: { message: string, subject: string, selectedEmails: string, }) {
        return axios({method: 'post', url: 'hotels/messaging/mail', data: data})
    }
}